import { w } from '@/lib/api'

export const createCheckoutSessionMutation = {
  mutationFn: (data: { priceId: string; successUrl: string; cancelUrl: string }): Promise<string> =>
    w
      .post(
        {
          price_id: data.priceId,
          success_url: data.successUrl,
          cancel_url: data.cancelUrl,
        },
        `/payment/v1/subscription/stripe/checkout`
      )
      .json(),
}
